import React, { useState } from "react";
import { BreadcrumbComponent } from "../../../common/components";
import { routes } from "../../../constants/routes";
import "./customer-engagement.scss";
import emailIcon from "../../../assets/icons/left-menu-icons/customer-engagement/email-compose-icon.svg";
import callIcon from "../../../assets/icons/left-menu-icons/customer-engagement/call-contact-icon.svg";
import surveyIcon from "../../../assets/icons/left-menu-icons/customer-engagement/survey-feedback-icon.svg";
import EastIcon from '@mui/icons-material/East';
import { NavLink } from "react-router-dom";
import EmailSetUpBanner from "../../../common/components/email-setup-required-banner/email-setup-banner";
import { useLogin } from "../../../common/hooks/useUser";

const CustomerEngagement: React.FC = () => {
  const breadcrumbLink = [
    { label: "Customer Management", link: "#", handleClick: () => { }, },
    { label: "Customer Engagement", link: routes.CUSTOMERENGAGEMENT },
  ];

  const loginDetails = useLogin();
  const isEmailConfigured = loginDetails?.isEmailConfigured;
  const isSuperAdmin = loginDetails?.userDetails?.roles?.role === "Super Admin";

  return (
    <div className="customer-engagement-wrapper">
      <div className="breadcrumb-wrapper">
        <BreadcrumbComponent breadcrumbLink={breadcrumbLink} />
      </div>
      {!isEmailConfigured && isSuperAdmin && (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <EmailSetUpBanner />
        </div>
      )}
      <div className="customer-engagement-content">
        <div className="customer-engagement-header">
          <h1>Customer Engagement Hub</h1>
          <p>
            Centralize your customer outreach with integrated tools for
            emailing, calling, and collecting feedback
          </p>
        </div>
        <div className="customer-engagement-cards">
          <div className="customer-engagement-card">
            <img src={emailIcon} className="email-icon" />
            <div>
              <h2>Compose & Send Emails</h2>
              <p>Reach out to customers directly on Email.</p>
            </div>
            <a
              className={`navigate-link`}
              href={ "mailto:" }
              onClick={(e) => {
                e.preventDefault();
              }}
            >
              Compose Email
              <EastIcon style={{fontSize: "14px"}} />
            </a>
          </div>
          <div className="customer-engagement-card">
            <img src={callIcon} className="call-icon" />
            <div>
              <h2>Contact Via Call</h2>
              <p>Connect via your preferred calling app.</p>
            </div>
            <a className="navigate-link" href="tel:">
              Call Now
              <EastIcon style={{fontSize: "14px"}} />
            </a>
          </div>
          <div className="customer-engagement-card">
            <img src={surveyIcon} className="survey-icon" />
            <div>
              <h2>Survey & Feedback</h2>
              <p>Send survey or feedback forms.</p>
            </div>
            <NavLink className="navigate-link" to={routes.VIEWSURVEY}>
              Select & Send
              <EastIcon style={{fontSize: "14px"}} />
            </NavLink>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CustomerEngagement;
